module.exports = __webpack_public_path__ + "img/total.74f85d9a.svg";